import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { DateSerializer } from 'shared';
import { Environment, ENVIRONMENT_TOKEN } from 'account-hybrid/core/environment.service';
import { GuestsV1ApiService } from 'apps/account/src/account-shared/services/guests-v1-api.service';
import { V1HttpShimService } from 'apps/account/src/account-shared/services/v1-http-shim.service';
import { selectStoriesLegacyViews } from '../store/stories-legacy-views.reducer';

/**
 * WS5 #10 Stage A (BroadcastModal port) — the redux-thunk-compatible dispatch
 * adapter over the NgRx `storiesLegacyViews` feature, extracted VERBATIM from
 * StoryModalLauncherService so the broadcast flows + the recommendation
 * notification can dispatch the account-v2 `PropertyApi`
 * fetch/close/createRecommendation thunks natively too.
 *
 * Thunk extras resolve natively (the inc 2e census: the only extras any
 * reachable thunk destructures are these four — the recommendation thunks use
 * exactly `{ $http, environment }`). Plain actions go to the NgRx store: only
 * RECOMMENDATIONS_FETCH_SUCCESS has a reducer case (stories reducer);
 * CLOSE/CREATE_RECOMMENDATION types are store-no-ops — same as the v1
 * ng-redux store (no reducer case there either).
 */
@Injectable({ providedIn: 'root' })
export class StoriesThunkDispatcherService {
  private readonly guestsApi = inject(GuestsV1ApiService);
  private readonly httpShim = inject(V1HttpShimService);
  private readonly environment = inject(ENVIRONMENT_TOKEN) as Environment;
  private readonly store = inject(Store);

  private readonly extraArgs: Record<string, any> = {
    dateSerializer: (date: any) => DateSerializer.serialize(date),
    Guests: this.guestsApi,
    $http: this.httpShim,
    environment: this.environment,
  };

  private storiesState: any = {};

  constructor() {
    this.store.select(selectStoriesLegacyViews).subscribe((s) => {
      if (s) this.storiesState = s;
    });
  }

  /** The current `views.stories` slice value (the launcher reads recommendations off it). */
  get state(): any {
    return this.storiesState;
  }

  dispatch = (action: any): any =>
    typeof action === 'function'
      ? action(this.dispatch, this.getState, this.extraArgs)
      : this.store.dispatch(action);

  getState = () => ({ views: { stories: this.storiesState } });
}
